import { useOidcIdToken } from '@axa-fr/react-oidc';
import { useEffect } from 'react';

import { useLayoutViewContext } from '@shared/context';
import { useUpdateLoginDateMutation } from '@shared/services/userProfile';
import { useAppDispatch, useAppSelector } from '@shared/stores/rootTypes';
import { loginDateSelector } from '@shared/stores/user/userSelector';
import { userAction } from '@shared/stores/user/userSlice';

const useUpdateLoginDate = () => {
  const { idTokenPayload } = useOidcIdToken();
  const dispatch = useAppDispatch();
  const loginDate = useAppSelector(loginDateSelector);
  const { isMobileView, isSharedServiceView } = useLayoutViewContext();

  const [updateLoginDate, { isLoading }] = useUpdateLoginDateMutation();

  useEffect(() => {
    if (idTokenPayload?.iat && idTokenPayload.iat !== loginDate) {
      if (!isMobileView && !isSharedServiceView) {
        updateLoginDate();
      }
      dispatch(userAction.setLoginDate(idTokenPayload.iat));
    }
  }, [loginDate, idTokenPayload, dispatch, updateLoginDate, isMobileView, isSharedServiceView]);

  return {
    isLoading,
  };
};

export default useUpdateLoginDate;
